import React, { useState } from "react";
import { Alert, Button, Form, InputGroup, Spinner } from "react-bootstrap";
import { FaEnvelope, FaUser } from "react-icons/fa";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../api";

const ForgotPassword = () => {
  const [identifier, setIdentifier] = useState("");
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setFeedback(null);

    try {
      const response = await axios.post(`${API_BASE_URL}/auth/forgot-password`, {
        identifier,
      });
      setFeedback({
        type: "success",
        message: response.data.message,
      });
    } catch (error) {
      setFeedback({
        type: "danger",
        message:
          error.response?.data?.error ||
          "Unable to request a password reset. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-container">
      <div className="auth-form-column">
        <div className="auth-card" style={{ maxWidth: "440px" }}>
          <div className="text-center mb-4">
            <img
              src="newlogo1.jpg"
              alt="CSD Logo"
              style={{ maxHeight: "58px", width: "auto", objectFit: "contain" }}
            />
          </div>

          <div className="text-start mb-4">
            <div
              className="d-inline-flex align-items-center justify-content-center mb-3"
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "50%",
                color: "var(--color-primary)",
                backgroundColor: "rgba(27, 58, 135, 0.1)",
              }}
            >
              <FaEnvelope />
            </div>
            <h3
              style={{
                color: "var(--color-primary)",
                fontWeight: 600,
                letterSpacing: "-0.5px",
              }}
            >
              Reset your password
            </h3>
            <p
              style={{
                color: "var(--color-text-secondary)",
                fontSize: "0.9rem",
                margin: 0,
              }}
            >
              Enter your student number or staff email. We’ll send reset
              instructions to the email linked to your account.
            </p>
          </div>

          {feedback && (
            <Alert variant={feedback.type} style={{ fontSize: "0.85rem" }}>
              {feedback.message}
            </Alert>
          )}

          <Form onSubmit={handleSubmit} className="text-start">
            <Form.Group className="mb-4">
              <Form.Label
                style={{
                  fontSize: "0.85rem",
                  fontWeight: 500,
                  color: "var(--color-text)",
                }}
              >
                Student Number or Email Address
              </Form.Label>
              <InputGroup>
                <InputGroup.Text
                  style={{
                    backgroundColor: "var(--color-bg)",
                    borderColor: "var(--color-border)",
                  }}
                >
                  <FaUser style={{ color: "var(--color-text-muted)" }} />
                </InputGroup.Text>
                <Form.Control
                  value={identifier}
                  onChange={(event) => setIdentifier(event.target.value)}
                  placeholder="Student number or staff email"
                  autoComplete="username"
                  required
                />
              </InputGroup>
            </Form.Group>

            <Button
              type="submit"
              disabled={loading}
              className="w-100"
              style={{
                backgroundColor: "var(--color-primary)",
                borderColor: "var(--color-primary)",
                borderRadius: "var(--radius-md)",
                padding: "0.75rem",
                fontWeight: 500,
              }}
            >
              {loading ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Sending...
                </>
              ) : (
                "Send Reset Link"
              )}
            </Button>
          </Form>

          <div className="text-center mt-4" style={{ fontSize: "0.9rem" }}>
            <Link
              to="/signin"
              style={{
                color: "var(--color-teal)",
                fontWeight: 500,
                textDecoration: "none",
              }}
            >
              Back to Sign In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
